import { colors } from '../colors.js';
export const menuBox = {
    variant: {
        neutral: { color: colors.text.default },
        destructive: { color: colors.text.error },
    },
};
//# sourceMappingURL=menu-box.js.map